import { render, staticRenderFns } from "./ListTransfers.vue?vue&type=template&id=6ca2fc3c&"
import script from "./ListTransfers.vue?vue&type=script&lang=js&"
export * from "./ListTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports